export default {
  publicPath: 'https://especiales.latercera.com/ironman-pucon',
  title: 'Ironman Pucón',
  description: 'Sigue de cerca el Ironman Pucón 2019',
  hashtag: '#mujeresdecienciaLT',
  brandtitle: 'Presentado por Skechers - Auspiciado por PF',
  reporttitle: 'Especiales La Tercera',
  img: '/content/share.jpg',
  slug: '/',
  site: {
    logo: 'assets/images/logos/latercera.svg',
    title: 'La Tercera',
    url: {
      name: "home"
    },
    height: '37'
  },
  lab: {
    logo: 'assets/images/logos-white/laboratorio-de-contenidos-de-marca.svg',
    title: 'Laboratorio de Contenidos',
    url: {
      name: "home"
    },
    height: '30'
  },
  brand: {
    logo: 'assets/images/logos-white/latercera.svg',
    title: 'La Tercera',
    url: {
      name: "home"
    },
    height: '20'
  },
  sponsors: {
    first: {
      logo: 'assets/images/logo-skechers-white.svg',
        title: 'Skechers',
          url: {
        name: "home"
      },
      height: '55'
    },
    second: {
      logo: 'assets/images/logo-pf.svg',
      title: 'PF',
      url: {
        name: "home"
      },
      height: '25'
    },
  },
  special: {
    logo: 'assets/images/logo-ironman-pucon.svg',
    title: 'Ironman Pucón',
    url: {
      name: "home"
    },
    height: '40'
  },
}